import React from 'react'

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeMap: Record<string, number> = {
  sm: 16,
  md: 24,
  lg: 32,
}

const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>(
  ({ size = 'md', ...rest }, ref) => {
    const pixelSize = sizeMap[size]

    return (
      <svg
        ref={ref}
        width={pixelSize}
        height={pixelSize}
        viewBox="0 0 24 24"
        fill="none"
        className="animate-spin text-current"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="32 16"
          opacity="0.9"
        />
      </svg>
    )
  }
)

Spinner.displayName = 'Spinner'

export default Spinner
